import { gql } from '@apollo/client';

export const SYNC_ORDERS_TO_SETTLEMENT_ORDER = gql`
  mutation SyncOrdersToSettlementOrder($trackingNos: [String!]!) {
    syncOrdersToSettlementOrder(trackingNos: $trackingNos)
  }
`;

export const UPLOAD_ORDER_SORT_RESULT = gql`
  mutation UploadOrderSortResult($fileBase64: String!, $fileName: String!) {
    uploadOrderSortResult(fileBase64: $fileBase64, fileName: $fileName)
  }
`;

export const TRIGGER_HOURLY_CYCLE_BILLING = gql`
  mutation TriggerHourlyCycleBilling {
    triggerHourlyCycleBilling
  }
`;

export const TRIGGER_DSP_ADJUST_BILL_PHASE4 = gql`
  mutation TriggerDspAdjustBillPhase4 {
    triggerDspAdjustBillPhase4 {
      alreadyRunning
      taskCount
    }
  }
`;
